var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"LKPublicationsContainer"},[_c('h3',{staticClass:"LKPublicationsContainer__title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }